<template>
<div>
  <Header />
  <div class="balance">
    <div class="check">
      <div class="check-row">
        <div class="check-column check-column__title">
          상품명
        </div>
        <div class="check-column check-column__contents" v-if="return_cd == '0000'">
          {{detail.product_name}}
        </div>
      </div>
      <div class="check-row mt15">
        <div class="check-column check-column__title">
          상품권번호
        </div>
        <div class="check-column check-column__contents" v-if="return_cd == '0000'">
          {{detail.gcct_no | voucher}}
        </div>
      </div>
      <div class="check-row mt15">
        <div class="check-column check-column__title">
          상품금액
        </div>
        <div class="check-column check-column__contents" v-if="return_cd == '0000'">
          {{detail.cnsmr_price | currency}}원
        </div>
      </div>
      <div class="check-row mt15">
        <div class="check-column check-column__title">
          유효기간
        </div>
        <div class="check-column check-column__contents" v-if="return_cd == '0000'">
          {{detail.valid_term_start_pit | date}} <span v-if="detail.valid_term_start_pit.length">~</span> {{detail.valid_term_end_pit | date}}
        </div>
      </div>
    </div>
    <div class="contents">
      <h2 class="contents__current">
        현재잔액
      </h2>
      <p class="contents__result" v-if="return_cd == '0000'">
        {{detail.last_rmnd_amt | currency}}원
      </p>
    </div>
      <div v-if="return_cd == '0000'" >
        <div class="list" v-for="(item , index) in items" :key="index">
          <div class="list-column">
            <p class="list-column list-column__title">{{item.xcg_bhf_name}}</p>
            <ul class="list-column list-column__date">
              <li class="list-column__date-itme">{{item.rgst_pit}}</li>
              <li class="list-column__date-itme">{{item.auth_proc_name}}</li>
            </ul>
          </div>
          <div class="list-column list-column__result" :class="{'list-column__result--blue' : item.auth_proc_code == 'L2'}">
            {{item.proc_amt | currency}}원 <span v-if="item.auth_proc_code == 'L2'">(환급)</span>
          </div>
        </div>
      </div>
      
      <div v-if="return_cd != '0000'" class="message-box">
        <p>잔액조회가 불가능한 상품권 입니다.</p> 
        <p>사유 : {{return_msg}}</p>
      </div>

  </div>
</div>
</template>

<script>
/* eslint-disable */
import Header from '@/components/Header';
import numeral from 'numeral';
import moment from 'moment';
import axios from 'axios';

export default {
  name: "Balance",
  components: {
    Header
  },
  data() {
    return {
      return_cd : '',
      return_msg : '',
      detail: {
        product_name : '',
        gcct_no : '',
        cnsmr_price : '',
        valid_term_start_pit : '',
        valid_term_end_pit : '',
        last_rmnd_amt : ''
      },
      items: []
    }
  },
  filters: { 
    currency: value => { 
      return numeral(value).format("0,0"); 
    },
    date: value => {
      console.log("data",moment(String(value)))
      return moment(String(value)).format('YYYY.MM.DD');
    },
    dateTime: value => {
      const str = String(value);
      return moment(str.substr(0,8)+' '+str.substr(8,4)).format('YYYY.MM.DD hh:mm');//2019.08.04 14:03
    },
    voucher: value => {
      return value.substring(0,4) + '******' + value.substring(value.length,value.length-2)
    }
  },
  created(){
    let pin = this.$route.params.pin;
    axios.post(process.env.ENDPOINT+'/balance/search', {
      pin: pin
    })
    .then(response => {
      if(response.status==200){
        console.log('response',response);
        let data = response.data;
        let detail = {};

        this.return_cd = data.return_cd;

        if(this.return_cd == '0000'){
          detail = data.response.data;
          this.detail.product_name = detail.product_name;
          this.detail.gcct_no = detail.gcct_no;
          this.detail.cnsmr_price = detail.cnsmr_price;
          this.detail.valid_term_start_pit = detail.valid_term_start_pit;
          this.detail.valid_term_end_pit = detail.valid_term_end_pit;
          this.detail.last_rmnd_amt = detail.last_rmnd_amt;
          this.items = data.response.list;
        }
        else{
          this.return_msg = data.return_msg;
        }
      }
    })
    .catch(error => {
      console.log(error);
    });
  },
  beforeMount(){

  },
  
  
};
</script>

<style scoped lang='scss'>

@import '@/assets/styles/mixin.scss';

.balance {
  width: 100%;
  margin: 0 auto;
  color: #222;
  font-size: 12px;
  letter-spacing: -0.5px;
  .check {
    padding: 20px;
    box-shadow: 0px 8px 14px -5px #e5e5e5 inset;
    .check-row {
      @include flexbox();
      @include align-items(center);
    }
    .check-column {
      &__title {
        color: #888;
        font-size: 12px;
        width: 72px;
      }
      &__contents {
        font-size: 14px;
        width: calc(100% - 72px);
      }
    }
  }
  .contents {
    height: 40px;
    padding: 15px 20px;
    background-color: #f5f5f5;
    box-sizing: border-box;
    @include flexbox();
    @include justify-content(space-between);
    @include align-items(center);
    &__result {
      font-size: 16px;
      color: #222;
      font-weight: 500;
    }
  }
  .list {
    padding: 20px;
    border-bottom: 1px solid #eee;
    @include flexbox();
    @include justify-content(space-between);
    @include align-items(center);
  }
  .list-column {
    &__date {
      margin-top: 10px;
      color: #888;
      @include flexbox();
      @include align-items(center);
    }
    &__date-itme {
      &:nth-child(2)::before {
        content: '|';
        margin: 0 2.5px;
        color: #e6e6e6
      }
    }
    &__result {
      font-size: 14px;
      font-weight: 500;
      &--blue {
        color: #13529a;
      }
    }
  }
}
.mt15 {
  margin-top: 15px;
}

.message-box{
  padding: 40px;
  font-size:14px;
  line-height: 40px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/Balance.vue